/**
 * After a deploy the files of the previous build are gone, and the host answers a request for one
 * of them with `index.html` (SPA fallback): a page that was already open then fails the next
 * lazy `import()` with «'text/html' is not a valid JavaScript MIME type» and sits on a black
 * screen. Vite fires `vite:preloadError` for exactly that; the fix is a reload, which fetches the
 * new `index.html` and with it the right file names. At most once per half minute, so a file that
 * is genuinely missing cannot turn into a reload loop.
 */
/** The few browser members this needs, typed here because `shared` is also built for Workers. */
interface BrowserLike {
  addEventListener(type: string, listener: (event: { preventDefault(): void }) => void): void;
  sessionStorage?: {
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
  };
  location: { reload(): void };
}

export function reloadOnStaleChunk(): void {
  const win = globalThis as unknown as BrowserLike;
  win.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    const KEY = 'akp-stale-chunk-reload';
    try {
      const last = Number(win.sessionStorage?.getItem(KEY) ?? 0);
      if (Date.now() - last < 30_000) return;
      win.sessionStorage?.setItem(KEY, String(Date.now()));
    } catch {
      /* no sessionStorage (private mode): reload anyway */
    }
    win.location.reload();
  });
}
